/**
 * Generates a unique realtime channel name to avoid
 * "cannot add callbacks after subscribe()" errors when a component
 * remounts (e.g. React StrictMode double-invoke in dev) and the old
 * channel hasn't finished tearing down yet.
 */
export function uniqueChannelName(base: string): string {
  const nonce =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID().slice(0, 8)
      : Math.random().toString(36).slice(2, 10);
  return `${base}-${nonce}`;
}
